module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/THE-LAKEHOUSE.8589c8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/THE-LAKEHOUSE.jpg
// module id = 9BSX
// module chunks = 0